import React, { useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import { LanguageContext } from '../../contexts/LanguageContext';
import { StyledMetrics, MetricsGrid, MetricCard } from './styles';

const Metrics = () => {
  const { theme } = useContext(ThemeContext);
  const { language, translations } = useContext(LanguageContext);

  const metrics = [
    {
      number: 160000,
      label: 'processes'
    },
    {
      number: 400,
      label: 'lawyers'
    },
    {
      number: 15,
      label: 'years'
    }
  ];

  return (
    <StyledMetrics>
      <div className="container">
        <MetricsGrid>
          {metrics.map((metric, index) => (
            <MetricCard key={index} data-aos="fade-up"  data-aos-delay={index * 50}>
              <span className="number counter" data-count={metric.number}>+{metric.number.toLocaleString()}</span>
              <span className="label">{translations[language][metric.label]}</span>
            </MetricCard>
          ))}
        </MetricsGrid>
      </div>
    </StyledMetrics>
  );
};

export default Metrics;
